<template>
  <div class="Checkout">

      <div class="Checkout-Section Left">
        <FormList></FormList>

        <back-button @click="$router.push({name: 'List', params: {  module_id: active_module.module_id, scrollParent: true }})">
          <p class="pull-right">{{ $t('checkout.title_back_description') }}</p>
        </back-button>

      </div>

      <div class="Checkout-Section right">
        <SummaryView></SummaryView>

        <PaymentList
          :currency="active_module.currency"
          :total="amount_with_modifiers_normal_after_coupon || amount_with_modifiers_normal"
          :total_partial="amount_with_modifiers_partial_after_coupon || amount_with_modifiers_partial"
          :gateways="active_module.gateways"
          :active_gateway="active_gateway"
          :error_code="decodeMessage"
          :selected_partial="selected_partial">
        </PaymentList>
      </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SummaryView from '../summary/SummaryView.vue';
  import PaymentList from './PaymentList.vue';
  import FormList from '../form/FormList.vue';
  import BackButton from './_partials/back-button.vue';

  export default {
    data () {
      return {
        scrollParent: true
      };
    },
    components: {
      SummaryView,
      PaymentList,
      FormList,
      BackButton
    },

    computed: {
      ...mapGetters([
        'active_module',
        'active_gateway',
        'cart',
        'amount_with_modifiers_normal',
        'amount_with_modifiers_normal_after_coupon',
        'amount_with_modifiers_partial',
        'amount_with_modifiers_partial_after_coupon',
        'visitor_modifiers',
        'selected_partial',
      ]),

      decodeMessage: function () {
        if (this.$route.params.error_code) {
          return window.atob(this.$route.params.error_code);
        } else {
          return '';
        }
      }
    }
  };
</script>

<style scoped>
  .Checkout {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .Checkout-Section {
    display: flex;
    min-width: 50%;
    padding: 1%;
  }

  .Left, .right {
    flex-direction: column;
  }

  @media screen and (max-width: 768px) {
    .Checkout {
      flex-direction: column;
    }

    .Left {
      flex-direction: column-reverse;
    }
  }
</style>



// WEBPACK FOOTER //
// Checkout.vue?6e1f7c18